/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import {
  Icon, Button, InfoBlock,
} from '@picsio/ui';
import {
  CloseIcon,
  FileUpload,
  Warning,
  Import,
  Csv,
  Excel,
  Json,
  Xml,
} from '@picsio/icons';
import Dropdown from '../../../../components/dropdown';
import Selection from './Selection';
import l10n from '../../../../shared/strings';
import Logger from '../../../../services/Logger';
import Spinner from '../../../../components/TreePlaceholder/Spinner';
import Stepper from '../../../../components/Stepper/Stepper';

import {
  stepLabels,
  formatOptions,
  importOptions,
  charsetOptions,
  delimiterOptions,
  separatorOptions,
  intercomDefaultMessage,
} from './config';
import './styles.scss';
import Tooltip from '../../../../components/Tooltip';

const iconMapping = {
  Csv,
  Json,
  Xml,
  Excel,
};

export default function useImportProducts() {
  const [modalOpen, setModalOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [format, setFormat] = useState('csv');
  const [importSetting, setImportSetting] = useState('new');
  const [separator, setSeparator] = useState({ value: ',', title: 'Comma (,)', _id: 'Comma' });
  const [delimiter, setDelimiter] = useState({ value: '"', title: 'Double quote (")', _id: 'DoubleQuote' });
  const [charset, setCharset] = useState({ value: 'utf-8', title: 'UTF-8', _id: 'UTF8' });
  const [loading, setIsLoading] = useState(false);

  useEffect(() => {
    if (step === 1) {
      Logger.log('User', 'SelectImportFormatModalOpened');
    } else if (step === 2) {
      Logger.log('User', 'ImportSettingsModalOpened');
    } else if (step === 3) {
      Logger.log('User', 'FileParsingSettingsModalOpened');
    } else if (step === 4) {
      Logger.log('User', 'UploadFileModalOpened');
    } else if (step === 5) {
      Logger.log('User', 'ImportValidationModalOpened');
    }
  }, [step]);

  const open = () => {
    Logger.log('User', 'ImportProductsIconClicked');
    setStep(1);
    setModalOpen(true);
  };
  const close = () => {
    setModalOpen(false);
    Logger.log('User', 'ImportProductsModalClosed', { step_name: stepLabels[step]?.title });
  };
  const selectFormat = (newFormat) => {
    setFormat(newFormat);
  };

  const logToAmplitude = () => {
    if (step === 1) {
      Logger.log('User', 'SelectImportFormatOptionSelected', { file_format: format });
    } else if (step === 2) {
      Logger.log('User', 'ImportSettingsModalOptionSelected', { import_mode: importSetting });
    } else if (step === 3) {
      Logger.log('User', 'FileParsingSettingsOptionSelected', {
        column_separator: separator.title,
        text_delimiter: delimiter.title,
        charset: charset.title,
      });
    }
  };

  const next = () => {
    logToAmplitude();
    setStep((s) => Math.min(s + 1, 4));
  };
  const prev = () => {
    Logger.log('User', 'ImportProductsModalBackClicked', { step_name: stepLabels[step] });
    setStep((s) => Math.max(s - 1, 1));
  };

  const handleFilesUpload = async (event) => {
    const { files } = event.target;
    Logger.log('User', 'UploadFileModalBrowseFilesClicked');
    if (files && files.length > 0) {
      Logger.log('User', 'UploadFileModalScanningFile', {
        file_name: files[0].name,
        file_type: files[0].type,
      });
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        setStep(5);
      }, 15000);
    }
  };

  const openChatWithSupport = async () => {
    Logger.log('User', 'ImportValidationModalContactSupport');
    await window.Intercom('showNewMessage');
    setTimeout(() => {
      window.Intercom('private:sendMessage', intercomDefaultMessage);
    }, 2000);
  };

  const handleDefaultCsvDownload = () => {
    Logger.log('User', 'DownloadSampleCSVButtonClicked');
    window.open('https://s3.us-east-1.amazonaws.com/docs.pics.io/samples/toriut_default.csv', '_blank');
  };

  const modal = modalOpen
    ? createPortal(
      <div className="simpleDialog">
        <div className="simpleDialogBox">
          <div>
            <div className="simpleDialogHeader">
              <div className="simpleDialogTitle main">
                {
                  step === 5 ? 'Import validation required' : `Step ${step} / ${stepLabels[step].title}`
                }
              </div>
              <span
                className="simpleDialogBtnCross"
                onClick={close}
              >
                <Icon>
                  <CloseIcon />
                </Icon>
              </span>
            </div>
            {/* HEADER */}
            <If condition={step !== 5}>
              <Stepper
                step={step}
                steps={Object.values(stepLabels)}
              />
            </If>
          </div>

          <div className="simpleDialogContent">
            <div className="import__body">
              {step === 1 && (
                <div className="options options--cards">
                  {formatOptions.map((o) => {
                    const IconComp = iconMapping[o.icon] || Csv;
                    return (
                      <Selection
                        isSelected={format === o.value}
                        icon={<IconComp />}
                        onChange={() => selectFormat(o.value)}
                        label={o.label}
                        className={`card ${format === o.value ? 'card--selected' : ''}`}
                      />
                    );
                  })}
                </div>
              )}

              {step === 2 && (
                <div className="options options--list">
                  {importOptions.map((o) => (
                    <Selection
                      isSelected={importSetting === o.value}
                      onChange={() => setImportSetting(o.value)}
                      label={o.label}
                      className={`card card--list ${importSetting === o.value ? 'card--selected' : ''}`}
                      description={o.description}
                    />
                  ))}
                </div>
              )}

              {step === 3 && (
                <>
                  <div className="form-group">
                    <label>Column separator</label>
                    <Dropdown
                      items={separatorOptions}
                      onCheckedHandler={(sep) => setSeparator(sep)}
                      checkedItems={[separator]}
                      createHandler={null}
                      isClose
                    />
                  </div>
                  <div className="form-group">
                    <label>Text delimiter</label>
                    <Dropdown
                      items={delimiterOptions}
                      onCheckedHandler={(delim) => setDelimiter(delim)}
                      checkedItems={[delimiter]}
                      createHandler={null}
                      isClose
                    />
                  </div>
                  <div className="form-group">
                    <label>Charset</label>
                    <Dropdown
                      items={charsetOptions}
                      onCheckedHandler={(char) => setCharset(char)}
                      checkedItems={[charset]}
                      createHandler={null}
                      isClose
                    />
                  </div>
                </>
              )}

              {step === 4 && (
                <div className="importPlaceholder">
                  <div className="innerContainer">
                    <div className="inner">
                      <Choose>
                        <When condition={loading}>
                          <Spinner text="Scanning file..." />
                        </When>
                        <Otherwise>
                          <div className="btnIconUpload">
                            <Icon>
                              <FileUpload />
                            </Icon>
                          </div>
                          <span className="placeholderTitle">
                            Click to browse your file
                            <span className="textDrop">{l10n.IMPORT.textDragNDrop}</span>
                          </span>
                          <input
                            accept={`.${format}`}
                            type="file"
                            onChange={handleFilesUpload}
                          />
                        </Otherwise>
                      </Choose>
                    </div>
                  </div>
                </div>
              )}
              {
                (step === 5) && (
                  <InfoBlock icon={() => <Warning />} iconColor="warning">
                    Import paused — some columns in your file don’t align with your Toriut product schema. Contact Support to map the fields and resume the upload.
                  </InfoBlock>
                )
              }
            </div>
          </div>
          {/* FOOTER */}
          <div className="simpleDialogFooter">
            <Choose>
              <When condition={step === 5}>
                <Button
                  color="secondary"
                  size="md"
                  variant="contained"
                  onClick={close}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  size="md"
                  variant="contained"
                  onClick={openChatWithSupport}
                >
                  Chat with support
                </Button>
              </When>
              <When condition={step < 4}>
                <Button
                  color="secondary"
                  size="md"
                  variant="contained"
                  onClick={step === 1 ? close : prev}
                >
                  {`${step === 1 ? 'Cancel' : 'Previous'}`}
                </Button>
                <Button
                  color="primary"
                  size="md"
                  variant="contained"
                  onClick={next}
                >
                  Next
                </Button>
              </When>
              <Otherwise>
                <Tooltip content="You can try the import operation using our product schema sample file">
                  <Button
                    onClick={handleDefaultCsvDownload}
                    color="primary"
                    disabled={loading}
                    startIcon={<Import />}
                    size="lg"
                    className="btnImport"
                  >
                    Download a sample CSV
                  </Button>
                </Tooltip>
              </Otherwise>
            </Choose>
          </div>
        </div>
      </div>,
      document.body,
    )
    : null;

  return { open, close, modal };
}
